<div fxFlex fxLayout="column" class="integrate-box">
  <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
    <mat-icon>close</mat-icon>
  </button>
  @if (bot.zendesk_is_active) {
    <div fxFlex="none">
      <p>{{ integratedLabel }}</p>
      <a mat-raised-button (click)="unintegrate()">{{ unintegrateLabel }}</a>
    </div>
  }
  @if (!bot.zendesk_is_active) {
    <div fxFlex="none">
      <app-channels-zendesk></app-channels-zendesk>
    </div>
  }
</div>
